import { FilteringOptions, ValidationFunction } from '../config';

export const filterBuilder = (filteringOptions: FilteringOptions, validationFunction: ValidationFunction) => {
  return {
    filteringOptions,
    validationFunction,
  };
};
